import { createMRTColumnHelper, MRT_ColumnDef } from "material-react-table";
import { Place } from "../../types/place";
import {
  publishedIdColumn,
  EntityWithMetadataTableSuffixColumns,
  withFieldProofreadingIndicator,
  createEntityFilterSpec,
} from "./EntityUtils";
import type { FilterSpec } from "../../hooks/useServerFilters";
import {
  formatLinksList,
  LinksList,
} from "../../components/forms/common/subForms/LinksListField";

const columnHelper = createMRTColumnHelper<Place>();

const createPlaceColumns = (
  withProofreading: boolean = false
): MRT_ColumnDef<Place, any>[] => [
  publishedIdColumn,
  columnHelper.accessor("name", {
    header: "Name",
    Cell: ({ cell }) => cell.getValue() || "-",
  }),
  columnHelper.accessor("cultural_sphere", {
    header: "Cultural Sphere",
    Cell: withFieldProofreadingIndicator(
      "cultural_sphere",
      ({ cell }) => cell.getValue() || "-",
      withProofreading
    ),
  }),
  columnHelper.accessor("other_designations", {
    header: "Other Designations",
    Cell: withFieldProofreadingIndicator(
      "other_designations",
      ({ cell }) => {
        const value = cell.getValue();
        return Array.isArray(value)
          ? value.join(", ")
          : value?.toString() || "-";
      },
      withProofreading
    ),
  }),
  columnHelper.accessor("external_links", {
    header: "External Links",
    Cell: withFieldProofreadingIndicator(
      "external_links",
      ({ cell }) => {
        const input = cell.getValue() as LinksList;
        return formatLinksList(input);
      },
      withProofreading
    ),
  }),
  columnHelper.accessor("region.parent", {
    header: "Region",
    Cell: withFieldProofreadingIndicator(
      "region",
      ({ cell }) => cell.getValue() || "-",
      withProofreading
    ),
  }),
  columnHelper.accessor("region.child", {
    header: "Sub-region",
    Cell: withFieldProofreadingIndicator(
      "region",
      ({ cell }) => cell.getValue() || "-",
      withProofreading
    ),
  }),
  columnHelper.accessor("type", {
    header: "Type",
    Cell: withFieldProofreadingIndicator(
      "type",
      ({ cell }) => cell.getValue() || "-",
      withProofreading
    ),
  }),
  ...EntityWithMetadataTableSuffixColumns,
];

export const placeColumns = createPlaceColumns();

export const placeTableColumns = createPlaceColumns(true);

export const placeFilterSpec: FilterSpec = createEntityFilterSpec({
  name: { kind: "string" },
  cultural_sphere: { kind: "string" },
  other_designations: { kind: "string" },
  external_links: { kind: "string" },
  "region.parent": { kind: "string" },
  "region.child": { kind: "string" },
  type: { kind: "string" },
});

export default placeColumns;
